// FeeCollection.jsx
import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { io } from "socket.io-client";



// -------------------- SOCKET --------------------
const socket = io(`${process.env.REACT_APP_API_BASE_URL}`);

function FeeCollection() {

  const [sessions, setSessions] = useState([]);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [students, setStudents] = useState([]);

  const [selectedSession, setSelectedSession] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");

  const [ledger, setLedger] = useState(null);
  const [classFees, setClassFees] = useState({});
  const [feeChecks, setFeeChecks] = useState({});
  const [paymentMode, setPaymentMode] = useState("monthly");
  const [paymentType, setPaymentType] = useState(""); // cash | cheque
  const [school, setSchool] = useState(null);
  const [receiptData, setReceiptData] = useState(null);
  
  const [chequeDetails, setChequeDetails] = useState({
    chequeNumber: "",
    bankName: "",
    chequeDate: "",
  });

  const [randomAmount, setRandomAmount] = useState("");
  const [availableConcessions, setAvailableConcessions] = useState([]);
  const [selectedConcession, setSelectedConcession] = useState(null);
  const monthMap = {
    month1: "April",
    month2: "May",
    month3: "June",
    month4: "July",
    month5: "August",
    month6: "September",
    month7: "October",
    month8: "November",
    month9: "December",
    month10: "January",
    month11: "February",
    month12: "March",
  };
  const formatFeeHead = (feeKey) => {
    // 🔹 Route / Van fee month-wise
    if (feeKey.startsWith("route_month")) {
      const monthKey = feeKey.replace("route_", ""); // month1, month2...
      return `Van Fee (${monthMap[monthKey]})`;
    }

    // 🔹 Normal monthly fees
    if (monthMap[feeKey]) {
      return monthMap[feeKey];
    }

    return feeKey.replace(/_/g, " ");
  };


  // -------------------- STYLES --------------------
  const label18 = { fontSize: "18px", fontWeight: "600" };
  const input14 = {
    fontSize: "14px",
    border: "1px solid #1E40AF",
    padding: "10px",
    borderRadius: "8px",
    width: "100%",
    background: "white",
  };
  const button18 = {
    fontSize: "18px",
    padding: "12px 26px",
    borderRadius: "8px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
  };

  // -------------------- LOAD SESSIONS --------------------
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/sessions/allSessions`)
      .then(res => setSessions(res.data));
  }, []);

  // -------------------- LOAD CLASSES --------------------
  useEffect(() => {
    if (!selectedSession) {
      setClasses([]);
      return;
    }

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`, {
      params: { sessionId: selectedSession }
    })
      .then(res => setClasses(res.data))
      .catch(() => setClasses([]));

    setSelectedClassId("");
    setSelectedClassName("");
    setSelectedSection("");
    setSelectedStudent("");
  }, [selectedSession]);
useEffect(() => {
  axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/api/school/getSchool`)
    .then(res => {
      if (res.data && res.data.length > 0) {
        setSchool(res.data[0]); // take first school
      }
    })
    .catch(err => {
      console.error("School fetch error", err);
    });
}, []);
  // -------------------- LOAD SECTIONS (FIXED) --------------------
  useEffect(() => {
    if (!selectedClassName || !selectedSession) {
      setSections([]);
      return;
    }

    axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/sections/${selectedClassName}/getSectionsByClassName`,
      { params: { sessionId: selectedSession } }
    )
      .then(res => setSections(res.data))
      .catch(() => setSections([]));

    setSelectedSection("");
    setSelectedStudent("");
  }, [selectedClassName, selectedSession]);

  // -------------------- LOAD STUDENTS --------------------
  useEffect(() => {
    if (!selectedClassName || !selectedSection || !selectedSession) {
      setStudents([]);
      return;
    }

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`, {
      params: {
        class: selectedClassName,
        section: selectedSection,
        sessionId: selectedSession,
      }
    })
      .then(res => setStudents(res.data))
      .catch(() => setStudents([]));

    setSelectedStudent("");
  }, [selectedClassName, selectedSection, selectedSession]);


  // -------------------- LOAD LEDGER --------------------
  useEffect(() => {
    if (!selectedStudent) return;

    socket.emit("join_student", selectedStudent);

    axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/ledgers/getLedgerByStudentId/${selectedStudent}`,
      {
        params: { sessionId: selectedSession }
      }
    )

      .then(res => {
        setLedger(res.data);
        setClassFees(res.data.feeHeads || {});
        const checks = {};
        Object.keys(res.data.feeHeads || {}).forEach(f => checks[f] = false);
        setFeeChecks(checks);
      });
  }, [selectedStudent]);

  // -------------------- LOAD CONCESSIONS --------------------
  useEffect(() => {
    if (!selectedClassId || !selectedSession) return;

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/concession/getconcession`, {
      params: {
        sessionId: selectedSession,
        classId: selectedClassId,
        section: selectedSection || "ALL",
      }
    })
      .then(res => setAvailableConcessions(res.data))
      .catch(() => setAvailableConcessions([]));
  }, [selectedClassId, selectedSection, selectedSession]);

  // -------------------- APPLY CONCESSION --------------------
const applyConcession = async (concession) => {
  console.log("✅ applyConcession called with:", concession);

  if (!ledger) return;

  const feeHeadKey =
    (concession.feeHeadName || "Total").replace(/\s+/g, "_");

  const payload = {
    studentId: selectedStudent,
    concessionData: {
      feeHeadConcessions: {
        [feeHeadKey]: {
          type: concession.discountType === "percentage" ? "%" : "Rs.",
          amount: concession.discount || concession.discountAmount || 0
        }
      }
    }
  };

  console.log("📤 Payload sent to backend:", payload);

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/concession/calculate`,
      payload
    );

    console.log("📥 Backend response:", res.data);

    setLedger(prev => ({
      ...prev,
      feeHeads: res.data.updatedLedger.feeHeads
    }));

    setClassFees(res.data.updatedLedger.feeHeads);
  } catch (err) {
    console.error("❌ Concession API error:", err.response?.data || err.message);
  }
};


  // -------------------- TOTAL --------------------
  const totalAmount =
    paymentMode === "random"
      ? Number(randomAmount || 0)
      : Object.keys(feeChecks).reduce((sum, f) => {
        if (feeChecks[f]) {
  sum += Number(classFees[f] || 0);
}

        return sum;
      }, 0);


  const resetSelectionFlow = () => {
    // selections
    setSelectedSession("");
    setSelectedClassId("");
    setSelectedClassName("");
    setSelectedSection("");
    setSelectedStudent("");

    // lists
    setClasses([]);
    setSections([]);
    setStudents([]);

    // ledger & fees
    setLedger(null);
    setClassFees({});
    setFeeChecks({});

    // concessions
    setAvailableConcessions([]);
    setSelectedConcession(null);

    // payment state
    setPaymentMode("monthly");
    setPaymentType("");
    setRandomAmount("");

    // cheque reset
    setChequeDetails({
      chequeNumber: "",
      bankName: "",
      chequeDate: "",
    });
  };


  const handleSubmit = async () => {
    if (!ledger || !selectedSession) {
      alert("Ledger or session missing");
      return;
    }

    const selectedFees =
      paymentMode === "monthly"
        ? Object.keys(feeChecks).filter(f => feeChecks[f])
        : ["RANDOM"];


    if (paymentMode === "monthly" && selectedFees.length === 0) {
      alert("Please select at least one fee");
      return;
    }

    if (paymentMode === "random" && (!randomAmount || randomAmount <= 0)) {
      alert("Please enter a valid amount");
      return;
    }
    // Payment Type validation (COMMON)
    if (!paymentType) {
      alert("Please select payment type (Cash / Cheque)");
      return;
    }

    // Cheque validation (COMMON)
    if (
      paymentType === "cheque" &&
      (!chequeDetails.chequeNumber ||
        !chequeDetails.bankName ||
        !chequeDetails.chequeDate)
    ) {
      alert("Please fill all cheque details");
      return;
    }

let paidMonths = [];
let paidFees = [];

if (paymentMode === "monthly") {
  Object.keys(feeChecks).forEach(f => {
    if (feeChecks[f]) {

      // month name
      const monthName = formatFeeHead(f);

      paidMonths.push(monthName);

      paidFees.push({
        feeHeadName: formatFeeHead(f),
        originalAmount: classFees[f],
        concession: 0,
        finalAmount: classFees[f],
        amountPaid: classFees[f]
      });
    }
  });
}

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/ledgers/payTotalFee`,
        {
          ledgerId: ledger._id,
          sessionId: selectedSession,
          totalAmount,
          selectedFees,
          paymentMode,
          randomAmount,
          paymentType,
          chequeDetails: paymentType === "cheque" ? chequeDetails : null,
          paidMonths,
          paidFees,
          concessionData: selectedConcession
          
  ? {
      feeHeadConcessions: {
        [selectedConcession.feeHeadName.replace(/\s+/g, "_")]: {
          type: selectedConcession.discountType === "percentage" ? "%" : "Rs.",
          amount:
            selectedConcession.discount ||
            selectedConcession.discountAmount ||
            0
        }
      }
    }
  : null


        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        }
      );


const receiptNo =
  res.data?.receiptNumber ||
  res.data?.receiptNo ||
  res.data?.receipt ||
  res.data?.data?.receiptNumber;

if (!receiptNo) {
  console.log("Full backend response:", res.data);
  alert("Receipt number missing from backend");
  return;
}

const studentObj = students.find(s => s._id === selectedStudent);

let feeDetails = [];

if (paymentMode === "monthly") {
  Object.keys(feeChecks).forEach(f => {
    if (feeChecks[f]) {
      feeDetails.push({
        name: formatFeeHead(f),
        amount: classFees[f]
      });
    }
  });
} else {
  feeDetails.push({
    name: "Random Amount",
    amount: randomAmount
  });
}

setReceiptData({
  receiptNo,
  date: new Date().toISOString().split("T")[0],
  studentName: studentObj?.firstName || "",
  fatherName: studentObj?.fatherName || "",
  className: selectedClassName,
  section: selectedSection,
  paymentType,
  feeDetails,
  totalAmount
});

// ✅ SHOW ALERT WITH RECEIPT NO
alert(
  `Payment Successful!\n\nReceipt No: ${receiptNo}\nAmount Paid: ₹${totalAmount}`
);
      
      // ---------------- CLEAN UI (NO RELOAD) ----------------

      // 1️⃣ Uncheck all fee checkboxes
      const clearedChecks = {};
      Object.keys(feeChecks).forEach(f => (clearedChecks[f] = false));
      setFeeChecks(clearedChecks);

      // 2️⃣ Reload ledger only (fresh data)
      // const ledgerRes = await axios.get(
      //   ` ${process.env.REACT_APP_API_BASE_URL}/api/ledgers/getLedgerByStudentId/${selectedStudent}`,
      //   { params: { sessionId: selectedSession } }
      // );

      // setLedger(ledgerRes.data);
      // setClassFees(ledgerRes.data.feeHeads);

    } catch (err) {
      console.error(err);
      alert(
        err.response?.data?.message || "❌ Payment failed"
      );
    }
  };
const generateReceiptPDF = () => {
  if (!receiptData || !school) {
    alert("Receipt not ready");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");

  const printReceipt = (startX) => {
    let y = 8;

    // ================= SCHOOL HEADER =================
    doc.setFontSize(11);
    doc.setFont(undefined, "bold");
    doc.text(school.schoolName || "", startX + 30, y, { align: "center" });
    y += 5;

    doc.setFont(undefined, "normal");
    doc.setFontSize(9);

    doc.text(school.address || "", startX + 30, y, { align: "center" });
    y += 4;

    doc.text(
      `School Code: ${school.schoolCode || ""}`,
      startX + 30,
      y,
      { align: "center" }
    );
    y += 4;

    doc.text(
      `(M): ${school.phone1 || ""}    (O): ${school.phone2 || ""}`,
      startX + 30,
      y,
      { align: "center" }
    );

    y += 7;

    // ================= TITLE =================
    doc.setFontSize(10);
    doc.setFont(undefined, "bold");
    doc.text("CASH RECEIPT", startX + 30, y, { align: "center" });

    y += 7;

    // ================= RECEIPT DETAILS =================
    doc.setFont(undefined, "normal");
    doc.setFontSize(9);

    doc.text(`Date: ${receiptData.date}`, startX, y);
    doc.text(`Receipt No: ${receiptData.receiptNo}`, startX + 35, y);
    y += 6;

    doc.text(`Name: ${receiptData.studentName}`, startX, y);
    y += 5;

    doc.text(`S/D/O: ${receiptData.fatherName}`, startX, y);
    y += 5;

    doc.text(
      `Class: ${receiptData.className} (${receiptData.section})`,
      startX,
      y
    );

    y += 6;

    // ================= TABLE HEADER =================
    doc.line(startX, y, startX + 60, y);
    y += 4;

    doc.setFont(undefined, "bold");
    doc.text("Fee Head", startX, y);

    // RIGHT ALIGNED HEADER
    doc.text("Amount", startX + 60, y, { align: "right" });

    y += 4;

    doc.setFont(undefined, "normal");

    // ================= FEE DETAILS =================
    receiptData.feeDetails.forEach((fee) => {
      doc.text(fee.name.toUpperCase(), startX, y);

      // RIGHT ALIGNED AMOUNT
      doc.text(`${fee.amount}`, startX + 60, y, { align: "right" });

      y += 5;
    });

    // ================= TOTAL =================
    doc.line(startX, y, startX + 60, y);
    y += 6;

    doc.setFont(undefined, "bold");
    doc.text("Total", startX, y);

    // RIGHT ALIGNED TOTAL
    doc.text(`Rs. ${receiptData.totalAmount}`, startX + 60, y, {
      align: "right",
    });

    y += 6;

    // ================= PAYMENT MODE =================
    doc.setFont(undefined, "normal");
    doc.text("Pay Mode", startX, y);

    // RIGHT ALIGNED PAYMENT TYPE
    doc.text(receiptData.paymentType.toUpperCase(), startX + 60, y, {
      align: "right",
    });

    y += 10;

    // ================= FOOTER =================
    doc.setFont(undefined, "bold");
    doc.text(`For ${school.schoolName}`, startX + 30, y, { align: "center" });
    y += 6;

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.text(
      "This is computer generated receipt. No signature required.",
      startX + 30,
      y,
      { align: "center" }
    );
  };

  // LEFT SIDE → School Copy
  printReceipt(10);

  // RIGHT SIDE → Parent Copy
  printReceipt(110);

  // Divider line
  doc.line(105, 5, 105, 290);

  // ================= PRINT DIRECTLY =================
  const blob = doc.output("blob");
  const blobUrl = URL.createObjectURL(blob);

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = blobUrl;

  document.body.appendChild(iframe);

  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  };
};            
  // -------------------- UI --------------------
  return (
    <div className="w-full flex justify-center py-8 px-2">
      <div className="w-full max-w-5xl">
        <div className="bg-white p-6 rounded-xl shadow-md space-y-6">

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label style={label18}>Select Session</label>
              <select value={selectedSession} onChange={e => setSelectedSession(e.target.value)} style={input14}>
                <option value="">Select Session</option>
                {sessions.map(s => (
                  <option key={s._id} value={s._id}>{s.sessionName}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={label18}>Select Class</label>
              <select
                value={selectedClassId}
                onChange={e => {
                  const value = e.target.value;

                  if (!value) {
                    // reset if "Select Class" is chosen
                    setSelectedClassId("");
                    setSelectedClassName("");
                    setSelectedSection("");
                    setSelectedStudent("");
                    return;
                  }

                  const cls = classes.find(c => c._id === value);
                  if (!cls) return;

                  setSelectedClassId(cls._id);
                  setSelectedClassName(cls.className);
                }}

                style={input14}
              >
                <option value="">Select Class</option>
                {classes.map(c => (
                  <option key={c._id} value={c._id}>{c.className}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label style={label18}>Select Section</label>
              <select value={selectedSection} onChange={e => setSelectedSection(e.target.value)} style={input14}>
                <option value="">Select Section</option>
                {sections.map(s => (
                  <option key={s._id} value={s.sectionName}>{s.sectionName}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={label18}>Select Student</label>
              <select value={selectedStudent} onChange={e => setSelectedStudent(e.target.value)} style={input14}>
                <option value="">Select Student</option>
                {students.map(st => (
  <option key={st._id} value={st._id}>
    {st.firstName} ({st.fatherName})
  </option>
))}
              </select>
            </div>
          </div>
          <div className="flex gap-6 mt-4">
            <label className="flex items-center gap-2 text-lg">
              <input
                type="radio"
                name="paymentMode"
                value="monthly"
                checked={paymentMode === "monthly"}
                onChange={() => setPaymentMode("monthly")}
              />
              Monthly Fee
            </label>

            <label className="flex items-center gap-2 text-lg">
              <input
                type="radio"
                name="paymentMode"
                value="random"
                checked={paymentMode === "random"}
                onChange={() => {
                  setPaymentMode("random");
                  setFeeChecks({}); // clear monthly selections
                }}
              />
              Random Amount
            </label>
          </div>

          {ledger && selectedStudent && (
            <div className="grid md:grid-cols-2 gap-6 mt-6">


              {/* ================= LEFT : FEE DETAILS ================= */}
              <div className="border rounded-lg p-4 bg-gray-50">
                <h3 className="text-lg font-semibold border-b pb-2 mb-3">
                  Fee Details
                </h3>

                {/* SCROLLABLE CONTAINER */}
                <div
                  className="space-y-2"
                  style={{
                    maxHeight: "300px",        // ✅ ~6 rows visible
                    overflowY: "auto",
                    paddingRight: "6px"
                  }}
                >
                  {paymentMode === "monthly" &&
  Object.keys(classFees)
    .filter(f => Number(classFees[f]) > 0)
    .map(f => (
      <div
        key={f}
        className="grid grid-cols-2 items-center py-2 border-b last:border-b-0"
      >
        <label className="flex items-center gap-3 text-sm font-medium">
          <input
            type="checkbox"
            checked={feeChecks[f] || false}
            onChange={() =>
              setFeeChecks(p => ({ ...p, [f]: !p[f] }))
            }
          />
          {formatFeeHead(f)}
        </label>

        <div className="text-right font-semibold text-blue-700 text-sm">
          ₹ {classFees[f]}
        </div>
      </div>
    ))}



                  {paymentMode === "random" && (
                    <div>
                      <label className="font-semibold text-sm">
                        Enter Amount (₹)
                      </label>
                      <input
                        type="number"
                        value={randomAmount}
                        onChange={e => setRandomAmount(e.target.value)}
                        placeholder="e.g. 10000"
                        style={input14}
                        className="mt-2"
                      />
                    </div>
                  )}
                </div>
              </div>


              {/* ================= RIGHT : STUDENT + SUMMARY ================= */}
              <div className="border rounded-lg p-4 bg-white">
                <h3 className="text-lg font-semibold border-b pb-2 mb-3">
                  Payment Summary
                </h3>

                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span>Student</span>
                    <span className="font-medium">
                      {students.find(s => s._id === selectedStudent)?.firstName}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span>Class</span>
                    <span className="font-medium">
                      {selectedClassName} - {selectedSection}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span>Session</span>
                    <span className="font-medium">
                      {sessions.find(s => s._id === selectedSession)?.sessionName}
                    </span>
                  </div>

                  <hr />

                  <div className="flex justify-between text-lg font-semibold">
                    <span>Total Payable</span>
                    <span className="text-green-600">
                      ₹{totalAmount}
                    </span>
                  </div>
                </div>
              </div>

            </div>
          )}

          {/* COMMON PAYMENT TYPE */}
          <div className="mt-4">
            <label style={label18}>Payment Type</label>

            <div className="flex gap-6 mt-2">
              <label className="flex items-center gap-2 text-lg">
                <input
                  type="radio"
                  name="paymentType"
                  value="cash"
                  checked={paymentType === "cash"}
                  onChange={() => setPaymentType("cash")}
                />
                Cash
              </label>

              <label className="flex items-center gap-2 text-lg">
                <input
                  type="radio"
                  name="paymentType"
                  value="cheque"
                  checked={paymentType === "cheque"}
                  onChange={() => setPaymentType("cheque")}
                />
                Cheque
              </label>
            </div>
          </div>
          {paymentType === "cheque" && (
            <div className="grid md:grid-cols-3 gap-4 mt-4">
              <div>
                <label style={label18}>Cheque Number</label>
                <input
                  type="text"
                  value={chequeDetails.chequeNumber}
                  onChange={e =>
                    setChequeDetails(p => ({ ...p, chequeNumber: e.target.value }))
                  }
                  style={input14}
                />
              </div>

              <div>
                <label style={label18}>Bank Name</label>
                <input
                  type="text"
                  value={chequeDetails.bankName}
                  onChange={e =>
                    setChequeDetails(p => ({ ...p, bankName: e.target.value }))
                  }
                  style={input14}
                />
              </div>

              <div>
                <label style={label18}>Cheque Date</label>
                <input
                  type="date"
                  value={chequeDetails.chequeDate}
                  onChange={e =>
                    setChequeDetails(p => ({ ...p, chequeDate: e.target.value }))
                  }
                  style={input14}
                />
              </div>
            </div>
          )}






          {paymentMode === "monthly" && (
            <div>
              <label style={label18}>Select Concession</label>
              <Select
  options={availableConcessions.map(c => ({
    value: c._id,
    label: `${c.headName} (${c.discountType === "percentage"
      ? c.discount + "%"
      : "₹" + c.discountAmount})`
  }))}

  onChange={o => {
    console.log("🔽 Concession dropdown selected:", o);

    const c = availableConcessions.find(x => x._id === o.value);

    console.log("📦 Full concession object:", c);

    setSelectedConcession(c);

    console.log("🚀 Calling applyConcession()");
    applyConcession(c);
  }}
/>

            </div>
          )}


          <div style={{ fontSize: "18px", fontWeight: "700" }}>
            Total Amount: ₹{totalAmount}
          </div>

          <div className="flex gap-4">
            {/* ✅ FIXED BUTTON */}
            <button
              onClick={handleSubmit}
              style={{ ...button18, background: "#1E40AF", color: "#fff" }}
            >
              Submit Payment
            </button>
            <button
  onClick={() => {
    resetSelectionFlow();
    setReceiptData(null);
  }}
  style={{ ...button18, background: "#EF4444", color: "#fff" }}
>
  Reset
</button>
            <button
  onClick={generateReceiptPDF}
  disabled={!receiptData}
  style={{
    ...button18,
    background: receiptData ? "#10B981" : "#9CA3AF",
    color: "#fff",
    cursor: receiptData ? "pointer" : "not-allowed"
  }}
>
  Print Receipt
</button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default FeeCollection;
